import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey } from '../../utils/keys';
export const useUpdateSpaceNotificationSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const memberSettingsKey = getMemberNotificationSettingsKey();
    return useMutation((variables) => client.notifications.updateSpaceSettings(variables), {
        onMutate: async (newSpaceSettings) => {
            await queryClient.cancelQueries(memberSettingsKey);
            const snapshot = queryClient.getQueryData(memberSettingsKey);
            queryClient.setQueryData(memberSettingsKey, old => {
                return {
                    ...old,
                    spaces: old.spaces.map(s => {
                        var _a, _b, _c, _d;
                        if (((_a = s === null || s === void 0 ? void 0 : s.space) === null || _a === void 0 ? void 0 : _a.id) === newSpaceSettings.spaceId &&
                            (s === null || s === void 0 ? void 0 : s.channel) === newSpaceSettings.channel) {
                            return {
                                ...s,
                                channel: newSpaceSettings.channel,
                                preference: (_b = newSpaceSettings.input.preference) !== null && _b !== void 0 ? _b : s.preference,
                                enabled: (_c = newSpaceSettings.input.enabled) !== null && _c !== void 0 ? _c : s.enabled,
                                sameAsDefault: (_d = newSpaceSettings.input.sameAsDefault) !== null && _d !== void 0 ? _d : s.sameAsDefault,
                            };
                        }
                        return s;
                    }),
                };
            });
            return { snapshot };
        },
        onError: (err, newSpace, context) => {
            // revert back the optimistic response
            queryClient.setQueryData(memberSettingsKey, context.snapshot);
        },
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(memberSettingsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateSpaceNotificationSettings.js.map